import React, { useState } from "react";
import "./ContactUsForm.css";
import Form from "react-bootstrap/Form";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { icon } from "@fortawesome/fontawesome-svg-core";
import {
  faCircleXmark,
  faEnvelope,
  faLocationDot,
  faMapLocationDot,
  faMaximize,
  faMinimize,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import OrangeFilledRoundBtn from "../../Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import SuccessModal from "../../Common-Component/Common_Modal/SuccessModal/SuccessModal";
import { useDispatch } from "react-redux";
import { contactusForm } from "../../../features/contact_us/contactusSlice";
import { RegxExpression } from "../../../utils/common";

const ContactUsForm = () => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("subject", data.subject);
    formData.append("contact_no", data.contact_no);
    formData.append("message", data.message);
 
    dispatch(contactusForm(formData));
    setShowSuccessModal(true);
    reset();
  };

  const contactData = [
    {
      text: "01123968786",
      icon: faPhone,
    },
    {
      text: "support@mansanutri.com",
      icon: faEnvelope,
    },
    {
      text: "516/4, Patil Nagar, Kashmere Gate Pune, Pune, 411038",
      icon: faLocationDot,
    },
    {
      text: "Find Us on Map",
      icon: faMapLocationDot,
      underline: true,
    },
  ];

  const [showMap, setShowMap] = useState(false);
  const handle = useFullScreenHandle();

  const toggleMap = () => {
    if (showMap && handle.active) {
      handle.exit();
    }
    setShowMap(!showMap);
  };

  const expandMap = () => {
    if (handle.active) {
      handle.exit();
    } else {
      handle.enter();
    }
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  return (
    <section className="ContactUsForm">
      <div className={`inner_contact_form ${showMap ? "hidden" : ""}`}>
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-12   me-0 p-0 ms-0">
            <div className="main_form_div">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    {...register("name", {
                      required: "Name is required",
                    })}
                    className={classNames("", {
                      "is-valid": getValues("name"),
                    })}
                  />
                  {errors?.name && (
                    <span className="invalid-feedback d-block">
                      {errors.name.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        message: "Invalid email address",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.email,
                      "is-valid": getValues("email"),
                    })}
                  />
                  {errors?.email && (
                    <span className="invalid-feedback d-block">
                      {errors.email.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Subject"
                    {...register("subject", {
                      required: "Subject is required",
                    })}
                    className={classNames("", {
                      "is-valid": getValues("Subject"),
                    })}
                  />
                  {errors?.name && (
                    <span className="invalid-feedback d-block">
                      {errors.name.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group">
                  {/* <Controller
                    name="contact_no"
                    control={control}
                    rules={{
                      required: "Contact number is required",
                      minLength: {
                        value: 10,
                        message: "Number should be at least 10 characters",
                      },
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        country={"in"}
                        enableSearch
                        onlyCountries={["in"]} // this restricts to India only (optional)
                        // masks={{ in: "(...) ...-...." }} // optional: for formatting
                        value={field.value}
                        onChange={(value) => field.onChange(value)}
                        inputProps={{
                          name: field.name,
                          required: true,
                          className: classNames("form-control", {
                            "is-invalid": errors?.contact_no,
                            "is-valid": getValues("contact_no"),
                          }),
                        }}
                        placeholder="Enter Mobile Number"
                      />
                    )}
                  /> */}

                  <Controller
                    name="contact_no"
                    control={control}
                    rules={{
                      required: "Field is required",
                      pattern: {
                        value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                        message:
                          "Invalid number format. Please enter a valid number with an optional country code",
                      },
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        country={"in"}
                        {...field}
                        className={classNames("", {
                          "is-invalid": errors?.contact_no,
                          "is-valid": getValues("contact_no"),
                        })}
                        onChange={(value) => field.onChange(value)}
                        type="text"
                        placeholder="Enter Mobile Number"
                        onKeyDown={(event) => {
                          if (!RegxExpression.phone.test(event.key)) {
                            if (event.key !== "Backspace") {
                              event.preventDefault();
                            }
                          }
                        }}
                        maxLength={10}
                      />
                    )}
                  />

                  {errors?.contact_no && (
                    <span className="invalid-feedback d-block">
                      {errors.contact_no.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="message"
                    placeholder="Your message"
                    {...register("message", {
                      required: "Message is required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.message,
                      "is-valid": getValues("message"),
                    })}
                  />
                  {errors?.message && (
                    <span className="invalid-feedback d-block">
                      {errors.message.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="form-group mt-xxl-5 mt-xl-4 mt-lg-3 mt-md-3 mt-sm-3 mt-4">
                  <Form.Check
                    type="checkbox"
                    id="agree"
                    label="I have read and agree to the Privacy Policy."
                    {...register("agree", {
                      required: "You must agree before submitting",
                    })}
                    className={classNames("", { "is-invalid": errors?.agree })}
                  />
                  {errors?.agree && (
                    <span className="invalid-feedback d-block">
                      {errors.agree.message}
                    </span>
                  )}
                </Form.Group>

                {/* <div className='send_btn_div' onClick={() => { setShowSuccessModal(true) }} > */}
                <div className="send_btn_div">
                  <OrangeFilledRoundBtn
                    btnText="Send Message"
                    type={"submit"}
                  />
                </div>
              </Form>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-12   me-0 p-0 ms-0">
            <div className="contact_us_info_main_div">
              {contactData?.map((item) => {
                return (
                  <div className="contact_us_info_div">
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={item?.icon} className="icon" />
                    </div>
                    <div className="text_holder">
                      <p
                        className="text"
                        onClick={item?.underline ? toggleMap : undefined}
                        style={{
                          textDecoration: `${
                            item?.underline ? "underline" : ""
                          }`,
                        }}
                      >
                        {item?.text}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <FullScreen handle={handle}>
        <div
          className={`map ${!showMap ? "hidden" : "show"} ${
            handle.active ? "fullscreen" : ""
          }`}
        >
          <iframe
            className="gmap_iframe"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
          ></iframe>
          <div className="close">
            <div className="map-icons">
              <FontAwesomeIcon
                icon={handle.active ? faMinimize : faMaximize}
                className="expand"
                onClick={expandMap}
              />
              <FontAwesomeIcon
                icon={faCircleXmark}
                className="close-icon"
                onClick={toggleMap}
              />
            </div>
          </div>
        </div>
      </FullScreen>

      <SuccessModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText="Message Sent Successfully!"
      />
    </section>
  );
};

export default ContactUsForm;
